import type { RouteRecordRaw } from 'vue-router'

/**
 * The kit gallery at `/_kit` (Phase 1). Every file in ./sections is one component's section; the kit agents each add
 * their own files, so they never edit a shared one. Registered in development and wherever `VITE_BETA_FEATURE` is on —
 * stage, so the product owner can review the kit — never in production. Public (no session), full layout.
 *
 * Reads `import.meta.env` directly, with the same `'true'` rule as src/app/config.ts: route files are evaluated while
 * the router is assembled, before `loadConfig()` runs, so `getConfig()` would throw here and stop the app from booting.
 */
const enabled = import.meta.env.DEV || import.meta.env.VITE_BETA_FEATURE === 'true'

const routes: RouteRecordRaw[] = enabled
  ? [
      {
        path: '/_kit',
        name: 'kit-gallery',
        component: () => import('./views/KitGallery.vue'),
        // The gallery mounts `DocumentPicker` (`documents.*` strings, queue #8).
        meta: { layout: 'full', public: true, catalogues: ['documents'] },
      },
    ]
  : []

export default routes
